<template>
    <div class="container">
        <!-- <img class="img" src="../../assets/bad.png" /> -->
        <div class="p_title">
            <!-- 帮助与咨询 -->
        </div>

        <div class="p_title" @click="onPress(1)">
            <img class="title_icon" :src="imgs[0]" />
            <span class="title_text">为什么需要货币才能聊天？</span>
            <span style="flex:1"></span>
            <img v-if="question1" class="title_arrow" src="../../assets/warning/ic_open.png" />
            <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
        </div>
        <div v-if="question1" class="p_content">
            <div class="line"></div>
                为了营造良好诚信的交友环境，也为了避免用户被过度骚扰，平台采取消耗货币的聊天交友模式，为有交友需求的用户双方搭建聊天互动的桥梁，秉持平台中立性的原则，聊天扣费权限完全交由用户自主设置。
                <nav style="margin-top: 20px"></nav>
                当用户设置聊天需付费时，聊天由主动方扣除金币，被动方无需扣除金币（恋爱天使牵线发起的聊天为系统匹配消息，回复即为主动方）。扣费规则男女相同不区分性别。
            </div>
        <div @click="onPress(2)" class="p_title">
            <img class="title_icon" :src="imgs[1]" />
            <span class="title_text">如何获得聊天货币？</span>
            <span style="flex:1"></span>
            <img v-if="question2" class="title_arrow" src="../../assets/warning/ic_open.png" />
            <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
        </div>
        <div v-if="question2" class="p_content">   
             <div class="line"></div>  
            <p class="content_desc">1、通过每日签到领取；</p>
            <p class="content_desc" style="margin-top: -16px">2、通过完成新手/每日任务获得相应货币/道具；</p>
            <p class="content_desc" style="margin-top: -16px">3、轻松充值，快速获得；</p>
        </div>

        <div @click="onPress(3)" class="p_title">
            <img class="title_icon" :src="imgs[2]" />
            <span class="title_text">充值后可以退款吗？</span>
            <span style="flex:1"></span>
            <img v-if="question3" class="title_arrow" src="../../assets/warning/ic_open.png" />
            <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
        </div>
        <div v-if="question3" class="p_content">
             <div class="line"></div>
            非常抱歉呢，虚拟货币一经充值成功，不支持退款哦，已充值的货币，您可以选择通过聊天/赠送礼物的方式进行消费使用。
        </div>

        <div @click="onPress(4)" class="p_title">
            <img class="title_icon" :src="imgs[3]" />
            <span class="title_text">如何让异性看到自己并和自己聊天？</span>
            <span style="flex:1"></span>
            <img v-if="question4" class="title_arrow" src="../../assets/warning/ic_open.png" />
            <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
        </div>
        <div v-if="question4" class="p_content">
             <div class="line"></div>
            首页有用户资料可进行查看并可发起主动聊天，为保障交友真实性，建议通过真人认证，来提高资料真实度，完善个人资料信息，来提升交友诚意度，资料越完整，曝光度也会随之提升哟！
        </div>

        <!-- 新增：付费规则 -->
        <div @click="onPress(12)" class="p_title">
            <img class="title_icon" :src="imgs[0]" />
            <span class="title_text">平台的聊天付费规则是什么样的？</span>
            <span style="flex:1"></span>
            <img v-if="question12" class="title_arrow" src="../../assets/warning/ic_open.png" />
            <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
        </div>
        <div v-if="question12" class="p_content">
            <div class="line"></div>
            聊天由主动方产生扣费（即首次发起聊天的一方），不区分性别（恋爱天使牵线发起的聊天为系统匹配消息，回复即为主动方）；礼物由赠送方消耗对应金币，接收方根据适时有效的平台规则获得相应的聊币；
            <nav style="margin-top: 16px"></nav>
            温馨提示：
            <nav style="margin-top: 4px"></nav>
            双方亲密度等级达到4级即可免费文字聊天；
            <nav style="margin-top: 4px"></nav>
            双方成为彼此的守护天使即可免费音视频通话；
        </div>

        <div @click="onPress(5)" class="p_title">
            <img class="title_icon" :src="imgs[4]" />
            <span class="title_text">如何通过真人认证？</span>
            <span style="flex:1"></span>
            <img v-if="question5" class="title_arrow" src="../../assets/warning/ic_open.png" />
            <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
        </div>
        <div v-if="question5" class="p_content">
             <div class="line"></div>
            真人认证是提高您真实度的一种方式，您只需要上传您的真实正脸照片作为头像照，并在真人认证页面打开您的摄像头根据指令做出相应动作进行人脸识别比对即可。
            以下情况将不会通过系统审核：
            <p>1.性别不符；</p>
            <p>2.头像照片人脸不清晰或有遮挡，无法识别头像人脸；</p>
            <p>3.拍摄时光线过暗、过亮或镜头模糊不清晰，五官有遮挡，无法识别人脸；</p>
            <p>4.五官识别与头像非同一人。</p>
        </div>



        <div @click="onPress(6)" class="p_title">
            <img class="title_icon" :src="imgs[5]" />
            <span class="title_text">亲密度等级有何作用？如何提升？</span>
            <span style="flex:1"></span>
            <img v-if="question6" class="title_arrow" src="../../assets/warning/ic_open.png" />
            <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
        </div>
        <!-- <div v-if="question6" class="p_content">
             <div class="line"></div>
            亲密度是双方亲密程度的体现，没有任何解锁用途，仅做展示使用，互动越频繁，亲密度越高哦！
        </div> -->
        <div v-if="question6" class="p_content">
             <div class="line"></div>
            亲密度等级是双方之间亲密程度的体现，亲密值通过私信聊天、音视频通话、赠送礼物进行提升，双方累计每产生100金币消耗即可增加1℃亲密值。
            <p>等级特权：</p>
            <p>亲密度4级：开放私信文字聊天免费（不包含音视频通话）；</p>
            <!-- <p>2、亲密度5级：开放互换联系方式信息（互换联系方式基于双方自愿前提，平台不干涉也无法保证双方后续发展）；</p> -->
        </div>




        <div @click="onPress(7)" class="p_title">
            <img class="title_icon" :src="imgs[6]" />
            <span class="title_text">是否可添加第三方联系方式？</span>
            <span style="flex:1"></span>
            <img v-if="question7" class="title_arrow" src="../../assets/warning/ic_open.png" />
            <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
        </div>
        <div v-if="question7" class="p_content">
            <div class="line"></div>
            基于对用户交友安全的保护，双方亲密等级未达到2级前，禁止发送第三方联系方式。双方亲密等级达到2级后，可根据双方个人意愿自由发送11位数字信息（例：13813813800）。初识阶段，请勿向他人透露个人隐私信息，谨防交友风险。
            <nav style="margin-top: 20px"></nav>
            温馨提示：
            <nav style="margin-top: 8px"></nav>
            1、基于对用户交友安全的保护，防止您的利益受损，本平台不建议您添加外部聊天工具（微信/QQ等），请谨慎交换外部联系方式，如涉及金钱相关，请保持高度警惕，谨防诈骗陷阱。在本平台内交友，安全有保障。
            <nav style="margin-top: 8px"></nav>
            2、平台不会对用户发送成功的信息进行空白屏蔽或字符替代，如对方反馈收不到，或者表示部分信息显示【***】号或者空白内容，对方可能存在故意欺瞒行为。如您发现对方存在违规行为，您可对该用户进行举报。
        </div>

        <div class="content_wrap">
            <div @click="onPress(13)" class="p_title">
                <img class="title_icon" :src="imgs[3]" />
                <span class="title_text">如何判断联系方式是否成功发送？</span>
                <span style="flex:1"></span>
                <img v-if="question13" class="title_arrow" src="../../assets/warning/ic_open.png" />
                <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
            </div>
            <div v-if="question13" class="p_content">
                <div class="line"></div>
                在您发送11位联系方式后，系统会显示以下提示内容
                <nav style="margin-top: 20px"></nav>
                <img style="width: 80%; margin-left: 10%;" src="../../assets/contact_send_sample.jpeg" />

                <nav style="margin-top: 20px"></nav>
                聊天页面若出现该提示内容，证明此条联系方式已成功发送，对方是可以完整查看到的。系统不会将您成功发送的信息进行任何修改，对方看到的信息与您聊天页面显示的均为一致的内容。
                <nav style="margin-top: 20px"></nav>
                温馨提示：如对方反馈信息空白、被字符替代或收不到此条信息等，说明对方存在故意欺瞒行为，请立即通过举报按钮对其进行举报。请勿轻信官方人员以外的人员描述的平台规则，平台倡导真实交友，严厉打击各类欺骗行为！
                </div>
        </div>



        <!-- <div v-if="question7" class="p_content">
             <div class="line"></div>
            交换联系方式均为双方意愿，平台未作出强制限制或屏蔽措施，更无需通过赠送礼物/提升亲密度来进行信息解锁，对于虚构平台规则进行欺诈行为，一经发现将作出严格的违规处理。为了保障您的安全，平台不建议您轻易对外透露私人联系方式信息，谨防第三方诈骗陷阱，在平台内聊天，安全有保障。如通过第三方平台聊天发生交友风险，我平台不予承担责任。
            温馨防骗警示：在聊天过程中，平台不会以任何形式限制发送联系方式（例：需要礼物解锁联系方式、系统提示礼物解锁联系方式、视频过程屏蔽数字、客服提示联系方式需要审核等）；去到外部聊天工具（微信、QQ等），涉及金钱相关内容，请保持高度警惕（此过程不受平台监管），谨防被骗。
        </div> -->

        <!-- <div @click="onPress(10)" class="p_title">
            <img class="title_icon_l" :src="imgs[10]" />
            <span class="title_text">为什么亲密度达到5级还是看不到联系方式？</span>
            <span style="flex:1"></span>
            <img v-if="question10" class="title_arrow" src="../../assets/warning/ic_open.png" />
            <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
        </div>
        <div v-if="question10" class="p_content">
            <div class="line"></div>
            当双方亲密度等级已达到5级，平台不会以任何形式屏蔽限制双方数字信息的发送，双方可完整查看到所有发送成功的数字信息内容。若对方反复强调“消息空白”、“有星号”、“只看到部分数字”、“语音报数字无声”、“视频报数字无声”等情况均为对方个人行为，并非平台屏蔽控制。如接收到对方的消息为“***”或空白等样式，均为对方人为输入*号或空白，不是系统处理成*号或空白的，交换联系方式信息均为双方个人意愿，平台不干涉其中。
        </div> -->

        <div @click="onPress(10)" class="p_title">
            <img class="title_icon_l" :src="imgs[10]" />
            <span class="title_text">如何查看亲密度？</span>
            <span style="flex:1"></span>
            <img v-if="question10" class="title_arrow" src="../../assets/warning/ic_open.png" />
            <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
        </div>
        <div v-if="question10" class="p_content">
            <div class="line"></div>
            您可以查看双方聊天对话页面顶端爱心的位置，爱心中显示的数值即为亲密度等级。点击爱心后会显示详细的亲密度规则。当双方亲密值达到1000℃，可享受免费文字聊天权益哟~
        </div>


        <div @click="onPress(11)" class="p_title">
            <img class="title_icon_l" :src="imgs[11]" />
            <span class="title_text">哪些行为会受到平台封号处理？</span>
            <span style="flex:1"></span>
            <img v-if="question11" class="title_arrow" src="../../assets/warning/ic_open.png" />
            <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
        </div>
        <div v-if="question11" class="p_content">
            <div class="line"></div>
            <p>1.存在涉黄涉政涉恐言论或行为；</p>
            <p>2.存在教唆其他用户注销账号或卸载软件等行为；</p>
            <p>3.存在诋毁平台或诋毁侮辱其他用户的行为；</p>
            <p>4.存在欺诈诱骗行为；</p>
            <p>5.假冒官方人员或编造官方虚假规则信息；</p>
            <p>6.使用外挂、脚本软件作弊获得平台货币；</p>
            <p>7.发布广告类内容；</p>
            <p>8.其他违法相关法律法规的行为。</p>
        </div>


        <div class="content_wrap">
            <div @click="onPress(14)" class="p_title">
                <img class="title_icon" :src="imgs[3]" />
                <span class="title_text">我发送地址信息为什么对方看不到？</span>
                <span style="flex:1"></span>
                <img v-if="question14" class="title_arrow" src="../../assets/warning/ic_open.png" />
                <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
            </div>
            <div v-if="question14" class="p_content">
                <div class="line"></div>
                除政治敏感地址外，常规地名、地址、小区名称、标志建筑等，用户均可正常发送。平台设有系统合规检测，如若涉及不合规内容，系统会如下图显示“发送消息违规”提示用户此条信息限制发送。
                <nav style="margin-top: 20px"></nav>
                <img style="width: 80%; margin-left: 10%;" src="../../assets/message_illegal.jpeg" />

                <nav style="margin-top: 20px"></nav>
                在无此系统提示的情况下，消息正常发送，即代表此条信息对方可完整查看到，系统不会以空白、字符替代等方式对信息内容进行屏蔽或修改。一切以系统提示为准，切勿轻信官方平台以外人员所描述的平台规则。
                <nav style="margin-top: 20px"></nav>
                温馨提示：交友初期，平台不建议您与陌生人轻易见面，请谨慎交往，以防受骗。
                </div>
        </div>


        <div @click="onPress(8)" class="p_title">
            <img class="title_icon" :src="imgs[7]" />
            <span class="title_text">开通贵族后聊天为什么还需要货币？</span>
            <span style="flex:1"></span>
            <img v-if="question8" class="title_arrow" src="../../assets/warning/ic_open.png" />
            <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
        </div>
        <div v-if="question8" class="p_content">
            <div class="line"></div>
            贵族是账户的尊贵体现，成为贵族后可以享有相应VIP特权(特权详情可在购买页面查看)，VIP特权中并不包括文字、语音、视频免费。
        </div>

        <div @click="onPress(9)" class="p_title">
            <img class="title_icon" :src="imgs[8]" />
            <span class="title_text">如何联系人工客服？</span>
            <span style="flex:1"></span>
            <img v-if="question9" class="title_arrow" src="../../assets/warning/ic_open.png" />
            <img v-else class="title_arrow" src="../../assets/warning/ic_close.png" />
        </div>
        <div v-if="question9" class="p_content">
            <div class="line"></div>
            <p class="content_desc">如果以上问答仍未能解答您的疑惑，您可点击下方按钮联系官方在线客服。</p>
            <p class="content_desc">此为官方平台唯一客服通道，本平台不会以任何官方名义添加用户私人联系方式传递本平台官方信息，一切官方规则均以平台内描述为准，请勿轻信非官方人员伪造描述的平台通知/消息/规则。</p>
            <!-- <p class="content_desc" style="margin-top: -16px"></p> -->
            <!-- <p class="content_desc" style="margin-top: -16px">我们的在线客服联系时间为：</p> -->
            <p class="content_desc">客服在线时间：10:00-12:00、13:00-19:00</p>
            <p class="content_desc" style="margin-top: -16px">（如遇排队情况，还请耐心等候，感谢您的理解！）</p>
            <!-- <p class="content_desc" style="margin-top: -16px">客服非在线时间可在线留言，客服上线后将在第一时间联系您</p> -->
        </div>

        <div class="button_sample" @click="goSample">
            【防骗指南】
        </div>

        <div style="margin-bottom: 100px">
        </div>

        <div v-if="!hideButton" class="kefu" style="" @click="kefu">
            <img class="kefu_bg" :src="imgs[9]" resize-mo />
            <!-- <div class="kefuButton">联系在线客服</div> -->
            <img v-if="isVip" class="kefu_vip" src="./imgs/icon_vip.png" />
        </div>
    </div>
</template>


<script>
import { sha256_digest } from '../../common/sha256';
import { IMG_COMMON, IMG_FAQ_1, IMG_FAQ_2, IMG_FAQ_3, IMG_FAQ_4 } from './consts';

export default {
    data() {
        return {
            question1: false,
            question2: false,
            question3: false,
            question4: false,
            question5: false,
            question6: false,
            question7: false,
            question8: false,
            question9: false,
            question10: false,
            question11: false,

            question12: false,  // 付费规则
            question13: false,  // 联系方式成功发送标准
            question14: false,  // 发地址为什么对方看不到

            id: '',
            name: '',
            // gender: '',
            isCheck: false,
            hideButton: '',
            pay: 0,
            complain: 0,
            complainId: 0,
            isVip: false,

            imgs: [],
            isFemale: false,
        }
    },

    created() {
        const url = window.location.href;
        const z = url.split('?');
        let p = {};

        try {
            const k = z[1].split('&');
            k.forEach(item => {
                const m = item.split('=');
                p[m[0]] = m[1];
            })
            this.id = p.id;
            this.name = p.name;
            // this.hideButton = p.gender == 2 && p.isCheck == 0;
            this.hideButton = false;
            this.isCheck = p.isCheck == 1;
            this.pay = p.pay == undefined ? -1 : p.pay;
            this.complain = p.complain == 1;
            this.complainId = p.complainId;
            this.isVip = p.vip > 0;

            this.isFemale = p.gender == 2;
        } catch(e) {}

        switch(p.edition) {
            case 'kameng':
                this.imgs = IMG_FAQ_2;
                break;

            case 'liaobei':
                this.imgs = IMG_FAQ_1;
                break;

            case 'yeliao':
                this.imgs = IMG_FAQ_3;
                break;

            case 'mitao':
                this.imgs = IMG_FAQ_4;
                break;

            default:
                this.imgs = IMG_COMMON;
                break;
        }
        // console.log('var si - - - -- - - ->', this.id, this.name, this.showServiceButton);
    },

    mounted() {
        
    },

    methods: {
        onPress(value) {
            // console.log('value si htis- - - - - - - - >', value);
            switch(value) {
                case 1:
                    this.question1 = !this.question1;
                    break;

                case 2:
                    this.question2 = !this.question2;
                    break;

                case 3:
                    this.question3 = !this.question3;
                    break;

                case 4:
                    this.question4 = !this.question4;
                    break;

                case 5:
                    this.question5 = !this.question5;
                    break;

                case 6:
                    this.question6 = !this.question6;
                    break;

                case 7:
                    this.question7 = !this.question7;
                    break;

                case 8:
                    this.question8 = !this.question8;
                    break;

                case 9:
                    this.question9 = !this.question9;
                    break;

                case 10:
                    this.question10 = !this.question10;
                    break;
                
                case 11:
                    this.question11 = !this.question11;
                    break;

                case 12:
                    this.question12 = !this.question12;
                    break;

                case 13:
                    this.question13 = !this.question13;
                    break;

                case 14:
                    this.question14 = !this.question14;
                    break;


                default:
                    break;
            }
        },

        kefu() {
            let url = '';
            if (this.id) {
                const nonce = 189823;
                const ts = (new Date()).getTime();
                const web_token = `${this.id}`;
                const key = 'de2099f7864d03102b3a2fdd4369d1b4';
                let sign_str = `nonce=${nonce}&timestamp=${ts}&web_token=${web_token}&${key}`;
                sign_str = sha256_digest(sign_str);
                sign_str = sign_str.toUpperCase();
                const complain = this.complain ? `[投诉:${this.complainId}]_` : '';
                const pay = this.pay != -1 ? `[¥:${this.pay}]_` : '';
                const check = this.isCheck ? `[审核人员]_` : '';
                const gender = this.isFemale ? '_女' : '_男';

                const cName = `${check}${complain}${pay}${this.name}_id:${this.id}${gender}`;
                // console.log('cName ish tis- - - - -- ->', cName);
                url = `https://1894876.s4.udesk.cn/im_client/?web_plugin_id=32596&nonce=${nonce}&timestamp=${ts}&web_token=${web_token}&signature=${sign_str}&encryption_algorithm=SHA256&c_name=${cName}`;
            } else {
                url = `https://1894876.s4.udesk.cn/im_client/?web_plugin_id=32596&`;
            }
            window.location.href = url;
        },

        goSample() {
            window.location.href = '/warning-sample';
        }
    }
}
</script>


<style scoped>
.container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #FFF;
}
.p_title {
    font-size: 16px;
    font-weight: 600px;
    margin: 20px 20px 4px 20px;
    align-items: center;
    /* background-color: #FF0000; */
    /* border-bottom-width: 100px; */
    /* border: 1px solid; */
    /* border-bottom-color: #FF0000; */
    display: flex;
}
.title_icon {
    width: 26px;
    height: 26px;
}
.title_icon_l {
    margin-left: -3px;
    width: 31px;
    height: 31px;
}
.title_arrow {
    width: 17px;
    height: 17px;
}
.title_text {
    margin-left: 8px;
}

.p_content {
    font-size: 15px;
    font-weight: 300px;
    margin: 4px 30px;
    color: #555;
}
.content_desc {
    font-size: 16px;
    font-weight: 400px;
}

.img {
    width: 40%;
    margin-top: 160px;
    margin-left: 30%;
}
.line {
    height: 1px;
    background-color: #EEE;
    margin: 6px 0px;
}

.kefu {
    position: fixed;
    display: flex;
    bottom: 20px;
    left: 10vw;
    width: 80vw;
    height: 13.2vw;
    border-radius: 10px;
    align-items: center;
    justify-content: center;
}
.kefu_bg {
    width: 80vw;
    height: 13.2vw;
    /* object-fit: contain; */
}
.kefu_vip {
    position: absolute;
    top: 1vw;
    right: 2vw;
    width: 6vw;
    height: 6vw;
    object-fit: contain;
}
.kefuButton {
    font-size: 20px;
    color: #FFF;
}

.button_sample {
    margin-left: 64vw;
    width: 36vw;
    height: 40px;
    border-radius: 4px;
    font-size: 16px;
    /* background-color: rgba(0, 0, 0, 0.2); */
    margin-top: 20px;
    color: #4169E1;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>